export default __webpack_public_path__ + "static/media/educational-society.f663703d.png";